import { Dispatch } from "redux";
import AuthService from "service/Auth";
import { setLoading } from "./global";
import { showMessage } from "utilities/helper";
import { AuthPayloadTypes } from "utilities/types/Auth";

export const loginAction =
  (form: AuthPayloadTypes, navigate: any) => async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    const payload = form;
    try {
      await AuthService.Login(payload);
      dispatch(setLoading(false));
      navigate("/");
    } catch (err: any) {
      console.log("error :", err);
      dispatch(setLoading(false));
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const logoutAction = (navigate: any) => async (dispatch: Dispatch) => {
  dispatch(setLoading(true));
  try {
    await AuthService.Logout();
    dispatch(setLoading(false));
    navigate("/login");
  } catch (err: any) {
    console.log("error :", err);
    dispatch(setLoading(false));
    showMessage(
      !err.response
        ? err.message
        : !!err.response?.data?.error
        ? err.response?.data?.error
        : err.response?.data?.message,
      "error"
    );
  }
};
